/** Shared red action buttons in the column filter popover. */
export const FILTER_POPOVER_CLEAR_BTN_STYLE = {
  padding: '4px 8px',
  background: '#f44336',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};
